import { Outlet, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PageHeader } from '@/components/dashboard/page-header';
import { SettingsNav } from '@/components/settings/settings-nav';

export const Route = createFileRoute('/_app/settings')({
  component: SettingsLayout,
});

function SettingsLayout(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Paramètres" subtitle="Préférences, sécurité, plan." />
      <SettingsNav />
      <Outlet />
    </div>
  );
}
